(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-slideshow-v1"] && !Shopify.designMode) return;
  try {
    
$('.section-slideshow-v1 .slick-side-h1').slick({
  autoplay: true, // Enable auto rotation
  autoplaySpeed: 5000, // Set the rotation speed in milliseconds (e.g., 5000 = 5 seconds)
  arrows: true, // Show navigation arrows
  dots: true // Show navigation dots
});

  } catch(e) { console.error(e); }
})();
})();
